import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { CustomMaterialModule } from './material.module';
import {FormsModule} from '@angular/forms';
import { TranslateModule, TranslateLoader} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr'; 
import { environment } from './../environments/environment';
import { AppConfig } from './app.config';
import { LoginService } from './services/login.service';
import { HttpService } from './services/http.service';
import { HomeService } from './services/home.service';
import {appRoutes} from './route';
import { RouterModule } from '@angular/router';
import { AuthGuardService } from './auth/auth-guard.service';
import { CacheService } from './services/cache.service';
import { PanelComponent } from './components/panel/panel.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load(environment.configFile);  
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    PanelComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CustomMaterialModule,
    FormsModule,
    HttpClientModule,
    ToastrModule.forRoot({
            closeButton: false,
            timeOut: 5000
          }), 
    TranslateModule.forRoot({
      loader : {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    RouterModule.forRoot(appRoutes,{ useHash: true})
  ],
  providers: [
    CacheService,
    LoginService, 
    HttpService, 
    AppConfig,
    HomeService,
    AuthGuardService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

